/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface DeleteAdvancedSearchHistory$Params {
  searchId: number;
}

export function deleteAdvancedSearchHistory(
  http: HttpClient,
  rootUrl: string,
  params: DeleteAdvancedSearchHistory$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(
    rootUrl,
    deleteAdvancedSearchHistory.PATH,
    'delete',
  );
  if (params) {
    rb.path('searchId', params.searchId, {});
  }

  return http
    .request(rb.build({ responseType: 'text', accept: '*/*', context }))
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({
          body: undefined,
        }) as StrictHttpResponse<void>;
      }),
    );
}

deleteAdvancedSearchHistory.PATH = '/me/advanced-search-history/{searchId}';
